<template>

    <div class="flex flex-col w-full canvas::editor-admin-ToolbarTop">

        <div class="w-full mb-0">
            <div class="flex">

                <div class="px-5 py-8 sm:px-8">

                    <div class="flex items-center">
                        <h4 class="inline-block text-xl font-semibold">{{ title }}</h4>

                        <button
                            class="px-2 py-1 ml-3 text-blue-500 rounded hover:bg-gray-50"
                            @click="$emit('update:fullscreen', !fullscreen)">
                            <i
                                class="far"
                                :class="fullscreen ? 'fa-compress-alt' : 'fa-expand-alt'"/>
                        </button>

                    </div>

                    <h6 class="text-gray-400">{{ instruction }}</h6>

                </div>

                <div class="flex px-5 py-8 ml-auto text-right versionInfo sm:px-8">

                    <div>
                        <div
                            class="label inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium"
                            :class="versionState === 'live' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'">
                            {{ versionState | camelcase }}
                        </div>

                        <h6 class="mt-2 mb-0 text-gray-500 card-subtitle" v-if="activeCanvasVersion">
                            {{ versionState === 'live' ? 'Gepubliceerd' : 'Live versie gepubliceerd' }}
                            <template v-if="authorName">door <b>{{ authorName }}</b></template>
                            op <b>{{ activeCanvasVersion.activated_at | date('%d-%m-%Y %H:%M') }}</b>
                        </h6>
                    </div>

                    <div v-if="currentLanguageToShow" class="ml-4">
                        <i class="flag-icon"
                           :class="'flag-icon-' + (currentLanguageToShow == 'en' ? 'gb' : currentLanguageToShow)"></i>
                    </div>

                </div>

            </div>
        </div>

    </div>

</template>

<script>

export default {

    props: {
        activeCanvasVersion: Object,
        canvasVersion: Object,
        versionState: String,
        activeMode: String,
        title: String,
        instruction: String,
        currentLanguageToShow: String,
        fullscreen: Boolean,
    },

    computed: {

        authorName() {
            return this.canvasVersion.canvas.author?.name;
        },

    },

}

</script>

<style lang="scss" scoped>

.canvas\:\:editor-admin-ToolbarTop {
    border-bottom: 1px solid #ddd !important;

    .card-subtitle.mb-0 {
        margin-bottom: 0 !important;
    }

    .flag-icon {
        font-size:  20px;
        margin-top: 3px;
    }

    .versionInfo h6 {
        margin: 5px 0 0 0 !important;
    }

}

</style>
